import { type ReactElement } from 'react';
import { Flex, Section } from '@fastnorth/kraken/components/layout';
import LegacyCertificate from './components/legacy-certificates/LegacyCertificate.tsx';
import { useParticipantDetails } from '../../hooks/ParticipantDetailsProvider.tsx';
import { H2 } from '@fastnorth/kraken/components/typography';
import { useTranslation } from 'react-i18next';
import FinisherCertificate from './components/FinisherCertificate.tsx';
import useAppLocation from '../../../../../../hooks/useAppLocation.ts';

const FinisherCertificateContainer = (): ReactElement | null => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'karwa.components.participant_details.finisher_certificate',
  });
  const [{ resultDetail }] = useParticipantDetails();
  const { isCertificatePreview } = useAppLocation();
  let certificateComponent: ReactElement | null = null;

  if (resultDetail?.finisherCertificateTemplate) {
    certificateComponent = <FinisherCertificate />;
  } else if (resultDetail?.finisherCertificate) {
    certificateComponent = <LegacyCertificate />;
  }

  if (!certificateComponent) {
    return null;
  }

  if (isCertificatePreview) {
    return certificateComponent;
  }

  return (
    <Section>
      <Flex gap={'4'} className={'justify-between'}>
        <H2 id={'finisher-certificate-section'}>{t('section_title')}</H2>
      </Flex>
      <Flex className="flex-col justify-between items-center align-middle lg:flex-row" gap={'5 0'}>
        {certificateComponent}
      </Flex>
    </Section>
  );
};

FinisherCertificateContainer.displayName = 'FinisherCertificateContainer';

export default FinisherCertificateContainer;
